import React from 'react';
import { FormGroup, Label, TextArea, FieldHelp } from './formPrimitives';
import { useTranslation } from '../../hooks/useTranslation.jsx';
import { KUUTIO_DEFAULT_INSTANCE_DESCRIPTION } from '@kuutio/shared/instanceContext.js';

/**
 * Prefill the editor with the shared default when the instance has no custom text.
 */
export function aiContextValueForForm(stored) {
  const trimmed = (stored || '').trim();
  return trimmed || KUUTIO_DEFAULT_INSTANCE_DESCRIPTION;
}

/**
 * Persist NULL when the editor still matches the shared default, so older
 * workshops keep using the code default instead of a frozen copy.
 */
export function aiContextValueForSave(edited) {
  const trimmed = (edited || '').trim();
  if (!trimmed || trimmed === KUUTIO_DEFAULT_INSTANCE_DESCRIPTION.trim()) return null;
  return trimmed;
}

/**
 * Per-instance Kuutio/workshop description injected into AI prompts as
 * {{instanceDescription}}. The shared default is shown as editable text.
 *
 * Stored at kuutio_instances.ai_context_description.
 */
function AiContextDescriptionField({ value, onChange, disabled = false }) {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Label>{t('instanceSettingsModal.labelAiContextDescription')}</Label>
      <TextArea
        name="ai_context_description"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={14}
      />
      <FieldHelp>{t('instanceSettingsModal.helpAiContextDescription')}</FieldHelp>
    </FormGroup>
  );
}

export default AiContextDescriptionField;
